const config = {
    "batchSize": 10,
    "buttons": {
        "doiRegex": /(?<=key=|doi.org\/)[^&]*|10\.\d+\/[^\/\?\&]+/,
        "class": "get-ftr-button",
    },
    "labels": {
        "access": {
            "open": "Open Access, freely available for everyone to read",
            "free": "Available for everyone to read for free",
            "permFree": "Available for everyone to read for free",
            "paid": "Access provided by your institution",
            "session": "Access provided in this session",
            "maybe": "Access provided by your institution but may be limited to certain users",
            "av": "Access to an alternative version is provided"
        },
        button: 'View'
    }
}

export default config;